import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { ActivityContentFields } from '../../activity-creation/ActivityContentFields';
import type { CreationForm } from './creationForm';
import type { CreationSubmission } from './useCreationSubmission';
import { useCreationStyles } from './useCreationStyles';
import {
  CreationProviderFields,
  CreationProviderPicker,
} from './CreationProviderFields';
import { CreationRepositoryFields } from './CreationRepositoryFields';

function CreationContentFields({
  content,
  board,
  providers,
  feedback,
}: CreationForm) {
  const { state, dispatch } = content;
  return (
    <ActivityContentFields
      title={state.title.value}
      description={state.description.value}
      descriptionVisible={Boolean(
        board.mode === 'blank' ||
          board.selectedWorkItem ||
          providers.isAgnostic ||
          state.description.dirty,
      )}
      importedContext={state.description.lastGenerated}
      card={state.card}
      titleError={feedback.fieldErrors.title}
      onTitleChange={value => {
        dispatch({ type: 'title.edited', value });
        feedback.clearFields('title');
      }}
      onDescriptionChange={value =>
        dispatch({ type: 'description.edited', value })
      }
    />
  );
}
function SubmittingDialog({ open }: { open: boolean }) {
  const classes = useCreationStyles();
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogContent>
        <div className={classes.loadingContainer}>
          <CircularProgress size={48} />
          <Typography variant="h6">Criando atividade...</Typography>
          <Typography variant="body2" color="textSecondary">
            Preparando o handoff web -&gt; terminal para a mesma activity.
          </Typography>
        </div>
      </DialogContent>
    </Dialog>
  );
}
function CreationFields({
  form,
  branchLabel,
}: {
  form: CreationForm;
  branchLabel: string;
}) {
  const classes = useCreationStyles();
  return (
    <DialogContent>
      {form.feedback.error && (
        <Alert severity="error" className={classes.field}>
          {form.feedback.error}
        </Alert>
      )}
      <CreationProviderPicker {...form} />
      <CreationProviderFields {...form} />
      <CreationRepositoryFields form={form} branchLabel={branchLabel} />
      <CreationContentFields {...form} />
    </DialogContent>
  );
}
export function CreationDialogView({
  open,
  form,
  actions,
  branchLabel,
}: {
  open: boolean;
  form: CreationForm;
  actions: CreationSubmission;
  branchLabel: string;
}) {
  if (actions.submitting) return <SubmittingDialog open={open} />;
  return (
    <Dialog
      open={open}
      maxWidth={form.board.showSection ? 'md' : 'sm'}
      fullWidth
      aria-labelledby="create-activity-dialog-title"
      onClose={(_event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown')
          actions.close();
      }}
    >
      <DialogTitle id="create-activity-dialog-title">
        Nova Atividade
      </DialogTitle>
      <CreationFields form={form} branchLabel={branchLabel} />
      <DialogActions>
        <Button onClick={actions.close}>Cancelar</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={actions.submit}
          disabled={!form.providers.selected || form.repository.loading}
        >
          Criar Atividade
        </Button>
      </DialogActions>
    </Dialog>
  );
}
